import { useQuery } from '@tanstack/react-query';
import { useApiClient } from 'utils/apiClient';
import { SalesReportTableParams } from 'utils/apiClient/services/reports/types';
import { normalizeRawSalesReports } from 'utils/apiClient/services/reports/schemas';

/* eslint-disable import/prefer-default-export */
export const useSalesReport = ({
  tableParams,
  enabled,
}: {
  tableParams: SalesReportTableParams;
  enabled: boolean;
}) => {
  const apiClient = useApiClient();
  const keyParams = {
    ...tableParams,
    ...(tableParams.sorter !== undefined && {
      sorter: {
        //@ts-ignore
        columnKey: tableParams.sorter.columnKey,
        //@ts-ignore
        order: tableParams.sorter.order,
      },
    }),
  };
  return useQuery({
    queryKey: ['reports', 'sales', keyParams],
    queryFn: () => apiClient.Reports.loadSalesReport(keyParams),
    enabled,
    select: (data) => ({
      data: normalizeRawSalesReports(data.data),
      total: data.total,
    }),
  });
};
